import React from "react";
import ContentsEn from "../components/pages/login/en/Contents";
import HeaderEn from "../components/header/en/Header";

const LoginEn = () => {
  return (
    <>
      <HeaderEn />
      <ContentsEn />
    </>
  );
};

export default LoginEn;
